import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

/**
 * Minimal text-input primitive — matches the visual tone of the other
 * `components/ui/*` files (border, focus ring on `--accent`, disabled
 * dimming). Forward-refs through to the underlying `<input>` so callers
 * can grab the DOM node for focus / measurement.
 *
 * Used so far by the Catalogue + CatalogueDrafts search boxes; expect to
 * grow more callsites once admin-UI gains more form surfaces.
 */
export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = "text", ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        "flex h-9 w-full rounded border border-border-light bg-bg-card px-3 py-2 text-sm text-text placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-accent disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
